export default __webpack_public_path__ + "static/media/RB.23c9aced.gif";